export default {
  floatingTopMenu: {
    openSettings: 'Einstellungen',
    showAbout: 'Allgemeine Informationen',
    about: 'Über ORS',
    openrouteserviceAPI: 'Openrouteservice API',
    openrouteserviceForDisasters: 'ORS für Katastrophenmanagement',
    askOpenrouteservice: 'Frage openrouteservice',
    settingsTooltip: 'Hier klicken um Einstellungen und andere Optionen anzupassen'
  }
}
